import { motion } from "framer-motion";
import { Play, ArrowUpRight, ImageIcon } from "lucide-react";

const sizeClasses = {
  regular: "md:col-span-4",
  wide: "md:col-span-8",
  tall: "md:col-span-4 md:row-span-2",
  large: "md:col-span-8 md:row-span-2",
};

export const CreationCard = ({ creation, index, onOpen }) => (
  <motion.button
    type="button"
    onClick={() => onOpen(creation)}
    data-testid={`creation-card-${creation.id}`}
    initial={{ opacity: 0, scale: 0.96 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: (index % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative overflow-hidden border border-border bg-card text-left min-h-[240px] ${sizeClasses[creation.size] || sizeClasses.regular}`}
  >
    <img
      src={creation.image_url || "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800"}
      alt={creation.title}
      className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

    <div className="absolute top-4 left-4 flex items-center gap-2">
      <span className="font-mono text-[10px] tracking-[0.15em] uppercase bg-black/50 backdrop-blur-md border border-white/10 px-2.5 py-1">
        {creation.game}
      </span>
    </div>
    <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center border border-white/20 bg-black/40 backdrop-blur-md group-hover:bg-volt group-hover:border-volt transition-colors duration-300">
      {creation.media_type === "video" ? <Play className="w-3.5 h-3.5 group-hover:text-white transition-colors duration-300" />
        : creation.media_type === "link" ? <ArrowUpRight className="w-4 h-4 group-hover:text-white transition-colors duration-300" />
        : <ImageIcon className="w-3.5 h-3.5 group-hover:text-white transition-colors duration-300" />}
    </div>

    <div className="absolute bottom-0 left-0 right-0 p-5">
      <h4 className="font-display font-bold text-xl tracking-tight uppercase">{creation.title}</h4>
      <p className="text-sm text-muted-foreground mt-1 line-clamp-2 max-w-md">{creation.description}</p>
    </div>
  </motion.button>
);
